/* tslint:disable */
/* eslint-disable */

/**
 * Status des PDF-Anhangs
 */
export enum WorkAccountingExportStatusEnum {
  Pending = 'pending',
  Preview = 'preview',
  Success = 'success',
  Failed = 'failed',
  NotApplicable = 'not_applicable',
  Revoked = 'revoked'
}
